import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { MaterialSuitability } from 'Components/Worksheets/AtterbergLimitWorksheet/types';
import { IWithWorksheetInjectedProps, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core/WorksheetEquipment';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import PlasticLimitTrialSection from './PlasticLimitTrialSection';

let BsEnIsoPlasticLimitSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const plResultNotObtainable = useSelector(
    pipe(
      createWorksheetSelector!('PlasticLimit.MaterialSuitability'),
      valueOrDefault(MaterialSuitability.MaterialSuitable),
      (ms) =>
        ms === MaterialSuitability.ResultCannotBeDetermined || ms === MaterialSuitability.NotTested_LLCouldNotBeObtained
    )
  );
  const llResultNotObtainable = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false))
  );

  const materialSuitabilityOptions = [
    { label: 'Material is suitable', value: MaterialSuitability.MaterialSuitable },
    {
      label: 'Not Tested - LL could not be obtained',
      value: MaterialSuitability.NotTested_LLCouldNotBeObtained,
      disabled: !llResultNotObtainable,
    },
    { label: 'Result cannot be determined', value: MaterialSuitability.ResultCannotBeDetermined },
  ];

  return (
    <>
      <SectionGroup heading="Plastic Limit Determination">
        <NamePrefixModifier appendNamePrefix="PlasticLimit">
          <ListFieldSection>
            <Field input={<RadioGroup />} name="MaterialSuitability" options={materialSuitabilityOptions} />
          </ListFieldSection>
          {!plResultNotObtainable && (
            <>
              <ListFieldSection>
                <WorksheetBalanceFieldSet name="Balance" />
                <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Oven" />
                <Field input={<NumericInput />} name="DryingTemperature" />
                <WorksheetBalanceFieldSet name="DryMassBalance" />
              </ListFieldSection>
              <PlasticLimitTrialSection />
            </>
          )}
        </NamePrefixModifier>
      </SectionGroup>
      <ListFieldSection heading="Result">
        {plResultNotObtainable ? (
          <Field input={<TextOutput />} label="Average Water Content (%)" value="N/A" />
        ) : (
          <Field input={<TextOutput />} name="Results.PlasticLimit" />
        )}
        <Field input={<TextOutput />} name="Results.PlasticLimitText" />
      </ListFieldSection>
    </>
  );
};

BsEnIsoPlasticLimitSection = withInjectedProps(BsEnIsoPlasticLimitSection);

export { BsEnIsoPlasticLimitSection };
export default BsEnIsoPlasticLimitSection;
